import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { LinkButton } from '@atlassian/mpac-primitives';
import React from 'react';
import { useExpander } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const Expander = _ref => {
  let {
    totalCount,
    text,
    maxCount,
    onChange
  } = _ref;
  const {
    showExpandButton,
    expanderClicked
  } = useExpander({
    totalCount,
    maxCount,
    onChange
  });
  return showExpandButton ? /*#__PURE__*/_jsx(LinkButton, {
    "aria-expanded": false,
    onClick: expanderClicked,
    iconAfter: /*#__PURE__*/_jsx(ChevronDownIcon, {
      label: "expand-icon"
    }),
    children: text
  }) : null;
};